export default "__VITE_ASSET__CiCL47Ew__"